import {FormGroup} from '@angular/forms';

export class Formulaire {
  // form: any = {};
  form: FormGroup;
  password_hide = true;
  password_hide2 = true;
  formfiles: any = [];
  arrayBuffer;
  selectedCount = 0;
  dataSelected;
  action = 'new';

  rowsCount = 0;

  uploadFile = false;
  listFiles: any = {};

  loading = false;
  error = false;
  errorMessage = localStorage.getItem('errorMessage');
  loadEXcelSpinner = false;
  listExcel = [];
  listSheets = [];
  ExcelWorkBook = null;


  constructor() {
  }

  /*initForm(data: any) {
    this.selectedCount = JSON.parse(localStorage.getItem('selectedCount'));
    this.dataSelected = JSON.parse(localStorage.getItem('dataSelected'));

    console.log(this.dataSelected);
    console.log(data);
    this.action = data.action;
    this.form.active = true;

    if (data.action !== 'new') {
      this.form = this.dataSelected[0];
    }
  }*/

  convertObjectToFormData(data: FormGroup) {
    this.form = data.value;
    const body = new FormData();
    for (const key in this.form) {
      if (this.form.hasOwnProperty(key) && this.form[key] !== 'null' && this.form[key] != null) {
        body.append(key, this.form[key]);
      }
    }
    return body;
  }

  onSuccess() {

  }

  setLoaded() {

  }

}
